<template>
  <modal :visible="visible" @close="close" :title="title" transition="fade">
    <div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ title }}</p>
        </header>
        <section class="modal-card-body">
          <textarea :class="{'textarea': true, 'is-danger': errors.has('message') }" name="message" v-validate="'required'" placeholder="Add a message" v-model="adminMessage"></textarea>
          <span v-show="errors.has('message')" class="help is-danger">{{ errors.first('message') }}</span>
        </section>
        <footer class="modal-card-foot">
          <a class="button is-primary" @click="handleMessage">{{ okText }}</a>
          <a class="button" @click="cancel">{{ cancelText }}</a>
        </footer>
      </div>
    </div>
  </modal>
</template>

<script>
import { Modal } from 'vue-bulma-modal'
import VeeValidate from 'vee-validate'
import Global from '../../../services/globalservice'
import Vue from 'vue'

Vue.use(VeeValidate, Global.VALIDATE_CONFIG)

export default {
  components: {
    Modal
  },

  props: {
    visible: Boolean,
    title: String,
    okText: String,
    cancelText: String,
    cancel: Function,
    reload: false,
    message: String
  },

  data () {
    return {
      adminMessage: null
    }
  },

  methods: {
    close () {
      this.$emit('close')
      if (this.reload) {
        window.location.reload()
      }
    },
    handleMessage () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$events.fire('complete-message', this.adminMessage)
          this.cancel()
        }
      })
    }
  },

  watch: {
    message () {
      this.adminMessage = this.message
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// NoteModal.vue?aba0c694